import { Variants } from 'motion/react'

// Every timing of the dialog's animation in seconds.
// The backdrop fades in while the card rises and grows into place, then the QR codes pop in one after the other,
// on close the card sinks and fades out a bit faster than the backdrop
export const dialogTiming = {
  open: {
    backdrop: { duration: 0.3, ease: [0, 0, 0.2, 1] },
    card: { duration: 0.45, ease: [0.2, 0, 0, 1] },
    // overshoots a bit, so the codes pop
    qrCode: { duration: 0.4, ease: [0.34, 1.56, 0.64, 1] },
    // the codes start once the card has mostly settled
    qrCodeDelay: 0.15,
    qrCodeStagger: 0.08,
  },
  close: {
    backdrop: { delay: 0.05, duration: 0.25, ease: [0.4, 0, 1, 1] },
    card: { duration: 0.2, ease: [0.4, 0, 1, 1] },
  },
} as const

export const backdropVariants: Variants = {
  hidden: { opacity: 0, transition: dialogTiming.close.backdrop },
  visible: { opacity: 1, transition: dialogTiming.open.backdrop },
}

export const cardVariants: Variants = {
  hidden: { opacity: 0, y: 24, scale: 0.96, transition: dialogTiming.close.card },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      ...dialogTiming.open.card,
      delayChildren: dialogTiming.open.qrCodeDelay,
      staggerChildren: dialogTiming.open.qrCodeStagger,
    },
  },
}

// the QR codes, they follow the card's variant and only animate in, the card takes them along on close
export const qrCodeVariants: Variants = {
  hidden: { opacity: 0, scale: 0.85 },
  visible: { opacity: 1, scale: 1, transition: dialogTiming.open.qrCode },
}
